/** Mises en page de la frise — valeur du champ `layout`. */
export const TIMELINE_LAYOUT_OPTIONS = [
  { label: 'Verticale — frise à gauche', value: 'vertical-left' },
  { label: 'Verticale — frise à droite', value: 'vertical-right' },
  { label: 'Horizontale — texte au-dessus', value: 'horizontal-text-top' },
  { label: 'Horizontale — texte en dessous', value: 'horizontal-text-bottom' },
];

/**
 * `layout` → géométrie du rendu.
 * `align` suit la prop Mantine `Timeline` (côté des puces) ; `textPosition`
 * n'a de sens qu'à l'horizontale, rendue à la main (Mantine ne la gère pas).
 */
export function resolveTimelineLayout(layout) {
  switch (layout) {
    case 'vertical-right':
      return { orientation: 'vertical', align: 'right', textPosition: null };
    case 'horizontal-text-top':
      return { orientation: 'horizontal', align: null, textPosition: 'top' };
    case 'horizontal-text-bottom':
      return { orientation: 'horizontal', align: null, textPosition: 'bottom' };
    default:
      return { orientation: 'vertical', align: 'left', textPosition: null };
  }
}

/** Segments de trait autour d'une puce : rien avant la 1ʳᵉ, rien après la dernière. */
export function timelineConnector(index, count) {
  return { before: index > 0, after: index < count - 1 };
}

/** Couleur des puces et du trait — vide = couleur principale du thème. */
export function timelineAccentColor(color) {
  return color || 'var(--mantine-primary-color-filled)';
}
